import { CardGenre, Card as CardType, ChaosTypes } from "../types";

interface ChaosCard extends CardType {
  activity: ChaosTypes | "other";
}

interface ChaosCardSub {
  activity: ChaosTypes | "other";
  description: string;
}

export const CHAOS_CARDS_SUB: ChaosCardSub[] = [
  {
    activity: "drink",
    description:
      "Go piss girl. A cup of piss must sourced. Someone must drink it.",
  },
  {
    activity: "clothes",
    description: "At least 1/2 of the players must remove 3 items of clothing.",
  },
  {
    activity: "clothes",
    description: "At least 1/2 of the players must remove 2 items of clothing.",
  },
  {
    activity: "clothes",
    description: "At least 1/2 of the players must remove 1 item of clothing.",
  },
  {
    activity: "clothes",
    description: "At least 1/2 of the players must add 1 item of clothing.",
  },
  {
    activity: "sex",
    description: "At least 1/3 of the players must kiss you.",
  },
  {
    activity: "sex",
    description:
      "A multi-way kiss must occur using at least 1/3 of the players.",
  },
  {
    activity: "sex",
    description: "At least 1/3 of the players must lick your nipples.",
  },
  {
    activity: "sex",
    description: "Lick the nipples of at least 1/3 of players",
  },
  {
    activity: "drink",
    description:
      "How's the pale ale? Let at least 1/3 of the players spit into a drink. Someone must finish it.",
  },
  {
    activity: "drink",
    description:
      "Save the group. Someone must go outside and pour a glass of water their pants.",
  },
  {
    activity: "clothes",
    description:
      "At least 1/2 of the players must wear their underwear on the outside..",
  },

  {
    activity: "other",
    description:
      "Save the group. Someone must let the group draw on their face.",
  },

  {
    activity: "drink",
    description:
      "Save the group. Someone must eat a spoonful of a condiment chosen by the group.",
  },

  {
    activity: "other",
    description:
      "Save the group. Someone must have ice cubes put down their shirt and keep them there for a round.",
  },

  {
    activity: "other",
    description:
      "Let the group decide. Someone must do 10 pushups with another player sitting on their back.",
  },

  {
    activity: "other",
    description:
      "Save the group. Someone must let the group put ice cubes in their socks for the next round.",
  },

  {
    activity: "sex",
    description: "At least 1/3 of the players must kiss your neck.",
  },
  {
    activity: "sex",
    description: "At least 1/3 of the players must slap your ass.",
  },

  {
    activity: "sex",
    description: "At least 1/3 of the players must suck your finger.",
  },
  {
    activity: "sex",
    description: "At least 1/3 of the players must spank you.",
  },
  {
    activity: "sex",
    description:
      "At least 1/3 of the players must feed you something with their mouth.",
  },
  {
    activity: "sex",
    description: "At least 1/3 of the players must let you lick their neck.",
  },
  {
    activity: "sex",
    description: "At least 1/3 of the players must let you spank them.",
  },
  {
    activity: "sex",
    description:
      "At least 1/3 of the players must let you feed them something with your mouth.",
  },
  {
    activity: "other",
    description:
      "At least 1/3 of the players must swap an item of clothing with each other.",
  },
  {
    activity: "other",
    description:
      "At least 1/3 of the players must do a conga line around the room.",
  },

  {
    activity: "other",
    description:
      "At least 1/3 of the players must perform a 30 second group dance routine.",
  },

  {
    activity: "other",
    description:
      "At least 1/3 of the players must do their best animal impression.",
  },
  {
    activity: "other",
    description: "At least 1/3 of the players must form a human pyramid.",
  },

  {
    activity: "other",
    description:
      "At least 1/3 of the players must swap shirts with each other.",
  },
];

export const CHAOS_CARDS: ChaosCard[] = CHAOS_CARDS_SUB.map((card) => ({
  ...(card as ChaosCard),
  quote: "Uncompleted card: Everyone drinks 5, card drawer drinks 10.",
  genre: "chaos" as CardGenre,
  penaltyCost: 3,
}));
